module.exports = __webpack_public_path__ + "img/og-procreate-5x_en.222e94d.jpg";